import React from 'react';
import { useTranslations } from '../utils/translations';
import illustrationImage from '../assets/illustration.png';
import './ExitConfirmation.css';

const ExitConfirmation = ({ currentLanguage, onConfirm, onCancel }) => {
  const { t } = useTranslations(currentLanguage);

  return (
    <div className="exit-confirmation-overlay">
      <div className="exit-confirmation-container">
        <div className="exit-confirmation-icon">
          ⚠️
        </div>
        
        <div className="exit-confirmation-content">
          <h2 className="exit-confirmation-title">{t('ui.exitConfirmation.title')}</h2>
          <p className="exit-confirmation-message">{t('ui.exitConfirmation.message')}</p>
        </div>
        
        <div className="exit-confirmation-actions">
          <button className="exit-confirmation-btn exit-confirmation-btn-no" onClick={onCancel}>
            {t('ui.exitConfirmation.no')}
          </button>
          <button className="exit-confirmation-btn exit-confirmation-btn-yes" onClick={onConfirm}>
            {t('ui.exitConfirmation.yes')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitConfirmation;
